import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "@/components/site/Reveal";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";
import { IMAGES } from "@/data/content";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter", { email, name: name || null });
      toast.success("You're on the list", { description: "Welcome to the Aruha Trails journal." });
      setEmail("");
      setName("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="newsletter" className="relative overflow-hidden bg-[#2b3a2e] px-6 py-28 lg:px-10 lg:py-36">
      <img
        src={IMAGES.hero}
        alt=""
        className="absolute inset-0 h-full w-full object-cover opacity-15"
      />
      <div className="relative mx-auto max-w-3xl text-center">
        <Reveal>
          <div className="overline mb-6 text-[#e7d2ad]">Stay well-informed</div>
          <h2 className="font-serif text-4xl font-medium leading-tight tracking-tight text-[#f6f3ec] lg:text-5xl">
            Join the <span className="italic text-[#e7d2ad]">journal.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-lg text-[#cdd3c8]">
            Be first to hear about new treks, retreats, mountain music evenings and seasonal cafe
            specials from the heart of Govind Wildlife Sanctuary.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <form onSubmit={submit} className="mx-auto mt-10 flex max-w-xl flex-col gap-3 sm:flex-row">
            <Input
              data-testid="newsletter-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="First name (optional)"
              className="h-12 rounded-none border-[#4a5a4c] bg-[#22301f] text-[#f6f3ec] placeholder:text-[#8fa08f] focus-visible:ring-[#e7d2ad] focus-visible:ring-1"
            />
            <Input
              data-testid="newsletter-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email"
              className="h-12 rounded-none border-[#4a5a4c] bg-[#22301f] text-[#f6f3ec] placeholder:text-[#8fa08f] focus-visible:ring-[#e7d2ad] focus-visible:ring-1"
            />
            <Button
              data-testid="newsletter-submit"
              type="submit"
              disabled={loading}
              className="h-12 shrink-0 rounded-none bg-[#ba5a45] px-8 text-xs font-semibold uppercase tracking-widest text-[#f6f3ec] hover:bg-[#9c4633]"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Subscribe"}
            </Button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
